import anime from 'animejs';
import Scene from '../classes/scene';
import SceneManager from '../classes/scene-manager';
import { ScrollDirection } from '../classes/scroll-manager';
import { getEl, getEls } from '../helpers';
import AnimationDebugger from '../components/animation-debugger';

export default class TransitionTech extends Scene {
	
	/** Where on the screen/window does the scroll count from? 0 = Top of the window, 1 = Bottom of the window, 0.5 = Middle of the window.**/
	static WINDOW_OFFSET: number = 0.9;
	
	sectionSelector = '#transition-tech';
	played: boolean = false;

	constructor(manager: SceneManager, targetContainer: string) {
		super(manager, targetContainer);
	}

	onExitedView(dir: ScrollDirection) {

	}

	onEnteredView(dir: ScrollDirection) {
		if (!this.played) {

			const els = getEls('.transition-imagery .image-frame');
			for (let i = 0; i < els.length; i++) {
				let thisel = els[i];
				setTimeout(() => {
					thisel.dispatchEvent(new CustomEvent('play'));
				}, i * 200);

			}
			this.played = true;
		}
	}

}
